"use client"
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Heart } from "lucide-react"
import Logo from "../../assets/im2.png"

export function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
        <div className="py-8 lg:py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              {/* Logo PolyMeet */}
              <div className="w-10 h-10 lg:w-20 lg:h-12 mr-3">
                <img src={Logo} alt="PolyMeet Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <h3 className="text-lg lg:text-xl font-bold text-[#5e17eb]">PolyMeet</h3>
                <p className="text-xs lg:text-sm text-gray-300">La réunion, autrement</p>
              </div>
            </div>

            <p className="text-gray-300 mb-6 leading-relaxed text-xs lg:text-sm max-w-md">
              PolyMeet facilite la transformation de vos réunions physiques en comptes-rendus, décisions et tâches exploitables.
            </p>

            {/* Newsletter */}
            <div className="mb-6">
              <h4 className="text-sm lg:text-base font-semibold mb-3 text-[#5e17eb]">Restez informé</h4>
              <p className="text-gray-300 mb-3 text-xs lg:text-sm">
                Recevez nos dernières nouveautés PolyMeet
              </p>
              <div className="flex max-w-md">
                <input
                  type="email"
                  placeholder="Votre email"
                  className="flex-1 px-3 py-2 lg:px-3 lg:py-2 bg-gray-800/50 border border-gray-700 rounded-l-lg lg:rounded-l-xl text-white placeholder-gray-400 focus:outline-none focus:border-[#5e17eb] backdrop-blur-sm text-xs lg:text-sm"
                />
                <button className="px-3 py-2 lg:px-4 lg:py-2 bg-gradient-to-r from-[#5e17eb] to-[#7c3aed] hover:from-[#7c3aed] hover:to-[#5e17eb] rounded-r-lg lg:rounded-r-xl transition-all duration-300 transform hover:scale-105">
                  <Mail className="w-4 h-4" />
                </button>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h4 className="text-sm lg:text-base font-semibold mb-3 text-[#5e17eb]">Suivez-nous</h4>
              <div className="flex space-x-3">
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-gray-800/50 hover:bg-gradient-to-br hover:from-[#5e17eb] hover:to-[#7c3aed] rounded-lg lg:rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 backdrop-blur-sm">
                  <Facebook className="w-4 h-4" />
                </button>
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-gray-800/50 hover:bg-gradient-to-br hover:from-[#5e17eb] hover:to-[#7c3aed] rounded-lg lg:rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 backdrop-blur-sm">
                  <Twitter className="w-4 h-4" />
                </button>
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-gray-800/50 hover:bg-gradient-to-br hover:from-[#5e17eb] hover:to-[#7c3aed] rounded-lg lg:rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 backdrop-blur-sm">
                  <Instagram className="w-4 h-4" />
                </button>
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-gray-800/50 hover:bg-gradient-to-br hover:from-[#5e17eb] hover:to-[#7c3aed] rounded-lg lg:rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 backdrop-blur-sm">
                  <Linkedin className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base lg:text-lg font-semibold mb-3 lg:mb-4 text-[#5e17eb]">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={scrollToTop} className="text-gray-300 hover:text-[#5e17eb] transition-colors text-xs lg:text-sm hover:translate-x-2 transform duration-300 block">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("about")} className="text-gray-300 hover:text-[#5e17eb] transition-colors text-xs lg:text-sm hover:translate-x-2 transform duration-300 block">
                  À propos
                </button>
              </li>
             
              <li>
                <button onClick={() => scrollToSection("contact")} className="text-gray-300 hover:text-[#5e17eb] transition-colors text-xs lg:text-sm hover:translate-x-2 transform duration-300 block">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base lg:text-lg font-semibold mb-3 lg:mb-4 text-[#5e17eb]">Contact</h4>
            <div className="space-y-3 lg:space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 lg:w-8 lg:h-8 bg-[#5e17eb]/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <MapPin className="w-3 h-3 lg:w-4 lg:h-4 text-[#5e17eb]" />
                </div>
                <div>
                  <p className="text-gray-300 text-xs lg:text-sm">Alger, Algérie</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-7 h-7 lg:w-8 lg:h-8 bg-[#5e17eb]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-3 h-3 lg:w-4 lg:h-4 text-[#5e17eb]" />
                </div>
                <a href="tel:+213665337925" className="text-gray-300 text-xs lg:text-sm hover:text-[#5e17eb] transition-colors">
                  +213 665 337 925
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-7 h-7 lg:w-8 lg:h-8 bg-[#5e17eb]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-3 h-3 lg:w-4 lg:h-4 text-[#5e17eb]" />
                </div>
                <a href="mailto:polymeet@example.com" className="text-gray-300 text-xs lg:text-sm hover:text-[#5e17eb] transition-colors">
                  polymeet@example.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700/50 py-4 lg:py-5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-gray-400 text-xs lg:text-sm">
              <span>© {new Date().getFullYear()} PolyMeet. Fait avec</span>
              <Heart className="w-4 h-4 text-red-500" />
              <span>pour vos réunions intelligentes.</span>
            </div>
            <div className="flex gap-6 text-xs">
              <button onClick={() => scrollToSection("about")} className="text-gray-400 hover:text-[#5e17eb] transition-colors">
                À propos
              </button>
              <button onClick={() => scrollToSection("contact")} className="text-gray-400 hover:text-[#5e17eb] transition-colors">
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
